import { useWorkingPatternRequestsByEmployeeIdQuery } from '../gql/graphql.generated';
import type { WorkingPatternRequestsByEmployeeIdQuery } from '../gql/graphql.generated';

export type ScheduleChangeRequest = NonNullable<
  NonNullable<WorkingPatternRequestsByEmployeeIdQuery['workingPatternRequestsByEmployeeId']>[number]
>;

export const useWorkingPatternRequests = (employeeId?: string, requestId?: string) => {
  const [result, refetch] = useWorkingPatternRequestsByEmployeeIdQuery({
    variables: { id: employeeId! },
    pause: !employeeId,
    requestPolicy: 'network-only'
  });

  const request = result.data?.workingPatternRequestsByEmployeeId?.find(item => String(item?.id) === requestId);

  return {
    ...result,
    request,
    refetch
  };
};
